import React, { Component } from 'react';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import FormControl from 'react-bootstrap/lib/FormControl';

class YearSelector extends Component {

    state = {
        // 2015 到明年，每年不用手加
        years: Array.from({ length: new Date().getFullYear() + 2 - 2015 }, (_, i) => 2015 + i),
    }

    render() {
        const { name, changeSelectedYear, selectedYear } = this.props;

        return (
            <FormGroup controlId={'formControlsSelect'+name} bsSize="small">
                <FormControl componentClass="select" placeholder="select" onChange={changeSelectedYear} value={selectedYear}>
                    <option value="0">{React.Component.prototype.$intl.get('年')}</option>
                    { this.state.years.map((year, index) =>  <option  key={index} value={ year }> { year } </option>)}             
                </FormControl>
            </FormGroup>
        );
    }
  
}

export default YearSelector;
